/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './FinancialStatementCard.module.scss';

import type { FinancialStatementCardProps, StatementRow, StatementTableProps } from './FinancialStatementCard.types';

const renderRow = (row: StatementRow, animated: boolean, rowIndex: number) => (
  <tr
    key={row.label}
    className={cn(row.total && styles.total, animated && styles.animatedRow)}
    style={animated ? { animationDelay: `${0.15 + rowIndex * 0.13}s` } : undefined}
  >
    <td>{row.label}</td>

    {row.values.map((value, i) => (
      <td key={i} className={cn(row.up && i === row.values.length - 1 && styles.up)}>
        {value}
      </td>
    ))}
  </tr>
);

export const StatementTable = ({ table, animated = false, className }: StatementTableProps) => (
  <table className={cn(styles.table, className)}>
    <thead>
      <tr>
        {table.columns.map((column) => (
          <th key={column}>{column}</th>
        ))}
      </tr>
    </thead>

    <tbody>{table.rows.map((row, index) => renderRow(row, animated, index))}</tbody>
  </table>
);

export const FinancialStatementCard = ({
  companyName,
  companyMeta,
  badge,
  table,
  source,
  className,
}: FinancialStatementCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <div>
        <h3 className={styles.name}>{companyName}</h3>
        <span className={styles.meta}>{companyMeta}</span>
      </div>

      <span className={styles.badge}>{badge}</span>
    </div>

    <StatementTable table={table} />

    <div className={styles.source}>
      <span className={styles.pin}>◉</span> {source}
    </div>
  </div>
);
